<script setup lang="ts">
// 路由懒加载 Suspense 回退骨架屏
// 在动态导入的 chunk 加载期间显示，避免白屏闪烁
// 注意：t-skeleton 没有 rows 属性，:rows="N" 只会渲染成无效 HTML 属性、
// 实际仍是一行默认骨架，必须用 row-col 显式描述每一行
import { useBreakpoint } from "@/composables/useBreakpoint";

const { isMobile } = useBreakpoint();

// 正文段落骨架：多条长短不一的文本行，行高与间距贴近真实排版
const paragraphRowCol = (widths: string[], height = "24px") =>
  widths.map((width) => [{ width, height }]);
</script>

<template>
  <div class="route-skeleton-container">
    <!-- 移动端：简单的行骨架 -->
    <template v-if="isMobile">
      <div class="mobile-skeleton">
        <t-skeleton :row-col="[{ width: '60%', height: '24px' }]" animation="gradient" class="sk-item" />
        <t-skeleton :row-col="paragraphRowCol(['100%', '92%', '96%', '70%'])" animation="gradient" class="sk-item" />
      </div>
    </template>
    <!-- 桌面端：卡片+行骨架 -->
    <template v-else>
      <div class="desktop-skeleton">
        <div class="sk-header">
          <t-skeleton :row-col="[{ width: '240px', height: '28px' }]" animation="gradient" />
        </div>
        <div class="sk-body">
          <div class="sk-left">
            <t-skeleton :row-col="paragraphRowCol(['100%', '96%', '100%', '88%', '60%'])" animation="gradient" />
          </div>
          <div class="sk-right">
            <t-skeleton
              :row-col="paragraphRowCol(['80%', '60%', '90%', '70%'], '20px')"
              animation="gradient"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.route-skeleton-container {
  width: 100%;
  padding: 16px 24px;
  min-height: 60vh;
}

.sk-header {
  margin-bottom: 20px;
}

.sk-body {
  display: flex;
  gap: 24px;
}

.sk-left {
  flex: 3;
}

.sk-right {
  flex: 1;
  margin-top: 24px;
}

.sk-item {
  margin-bottom: 16px;
}

/* 移动端骨架屏 */
.mobile-skeleton {
  padding: 8px;
}

@media (max-width: 800px) {
  .sk-body {
    flex-direction: column;
    gap: 16px;
  }

  .sk-right {
    flex: none;
    margin-top: 0;
  }
}
</style>
